/* eslint-disable */
import Vue from 'vue'
import 'babel-polyfill'
import store from '@/store'
import i18n from '@/i18n'

import '@/theme/index.css'
import App from './App.vue'
import router from '@/pages/index/router'
import '@/utils/rem.js'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'

import './registerZkComponet.js' // 自定义组件
import mixin from '@/mixins/index.js'
import dataFormat from '@/filtres/dataFormatFilter'
import VueClipboard from 'vue-clipboard2'

require('@/styles/index.less')

Vue.use(mixin)
Vue.use(dataFormat)
Vue.use(VueClipboard)

Vue.config.productionTip = false

const runtime = require('offline-plugin/runtime')
runtime.install()
runtime.applyUpdate()
// if ('serviceWorker' in navigator) {
//   try {
//     navigator.serviceWorker.getRegistration().then(registration => {
//       registration &&
//         registration.unregister().then(boolean => {
//           console.log(boolean)
//         })
//     })
//   } catch (error) {}
// }

router.beforeEach(function(to, from, next) {
  NProgress.start() // start progress bar
  if (to.fullPath === '/') {
    next({
      path: '/index'
    })
    NProgress.done()
  }
  if (to.meta.auth === false) {
    // 不需要鉴权
    next()
  } else {
    if (sessionStorage.getItem('isLogin') === 'true') {
      // 登陆即可访问
      next()
    } else {
      // 否则跳转到登陆页面
      next({
        path: '/login'
      })
    }
  }
})

router.afterEach((to, from, next) => {
  NProgress.done() // finish progress bar
})

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  store,
  i18n,
  router,
  data: {
    menus: [],
    activeMenu: {},
    appKey: '',
    wxAppid: '',
    wxCallbackAddress: ''
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/pages/index/main.js